import styled from 'styled-components';

export const StyledAboutHowItWorksSection = styled.div`
  .about-how-it-works-section {
    width: 100%;
    padding: 100px 16px;
    background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);

    &__inner {
      margin: 0 auto;
      max-width: 1200px;
    }

    &__heading {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-bottom: 60px;
      gap: 16px;

      p:last-child {
        max-width: 500px;
        color: ${({ theme }) => theme.colors.boulder};
      }
    }

    &__steps {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      gap: 24px;

      @media (max-width: 900px) {
        flex-direction: column;
        align-items: center;
      }
    }

    &__step {
      flex: 1;
      max-width: 260px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 20px;

      @media (max-width: 900px) {
        max-width: 400px;
      }
    }

    &__step-number {
      width: 72px;
      height: 72px;
      border-radius: 50%;
      background: linear-gradient(135deg, ${({ theme }) => theme.colors.mainOrange} 0%, #f97316 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 8px 24px rgba(249, 115, 22, 0.3);

      p {
        color: ${({ theme }) => theme.colors.white};
      }
    }

    &__step-content {
      display: flex;
      flex-direction: column;
      gap: 8px;

      p {
        color: ${({ theme }) => theme.colors.boulder};
      }
    }

    &__arrow {
      display: flex;
      align-items: center;
      padding-top: 24px;

      svg {
        font-size: 20px;
        color: ${({ theme }) => theme.colors.alto};
      }

      @media (max-width: 900px) {
        transform: rotate(90deg);
        padding-top: 0;
      }
    }
  }
`;
